export type MealType = 'breakfast' | 'lunch' | 'dinner' | 'snack';
export type Unit = 'g' | 'ml' | 'tbsp' | 'tsp' | 'pcs';
export type Category =
  | 'Produce'
  | 'Meat'
  | 'Dairy'
  | 'Dry Goods'
  | 'Spices'
  | 'Beverages'
  | 'Other';

export interface Ingredient {
  id: number;
  name: string;
  category: Category;
  default_unit: Unit;
  default_unit_weight_g: number | null;
  kcal_per_100: number;
  protein_per_100: number;
  carbs_per_100: number;
  fat_per_100: number;
  shoppable: boolean;
}

export interface RecipeIngredientLine {
  ingredient_id: number;
  name: string;
  amount: number;
  unit: Unit;
  kcal: number;
}

export interface PerPortion {
  kcal: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
}

export interface Recipe {
  id: number;
  title: string;
  meal_type: MealType;
  portions: number;
  prep_time_minutes: number;
  instructions: string;
  source_url: string | null;
  tags: string[];
  plannable: boolean;
  ingredients: RecipeIngredientLine[];
  per_portion: PerPortion;
}

export interface RecipeInput {
  title: string;
  meal_type: MealType;
  portions: number;
  prep_time_minutes: number;
  instructions: string;
  source_url?: string | null;
  ingredients: Array<{ ingredient_id: number; amount: number; unit: Unit }>;
  plannable?: boolean;
}

export interface ImportedIngredientDraft {
  id: number | null;
  name: string;
  amount: number;
  unit: string;
  is_new: boolean;
  needs_review: boolean;
}

export interface ImportResult {
  title: string;
  meal_type: 'Dinner';
  default_portions: number;
  servings_yield: string | number | null;
  prep_time_minutes: number;
  instructions: string;
  source_url: string;
  source_image_url?: string;
  ingredients: ImportedIngredientDraft[];
  warnings: string[];
  unrecognized_ingredients: Array<{
    name: string;
    parsed_amount: number;
    parsed_unit: string;
  }>;
}

export const MEAL_TYPES: readonly MealType[] = ['breakfast', 'lunch', 'dinner', 'snack'];
export const UNITS: readonly Unit[] = ['g', 'ml', 'tbsp', 'tsp', 'pcs'];
export const IMPORTED_UNITS: readonly string[] = [
  'g',
  'kg',
  'ml',
  'l',
  'tsp',
  'tbsp',
  'cup',
  'oz',
  'lb',
  'pinch',
  'pcs',
  'clove',
  'can',
  'slice',
  'piece',
];
export const CATEGORIES: readonly Category[] = [
  'Produce',
  'Meat',
  'Dairy',
  'Dry Goods',
  'Spices',
  'Beverages',
  'Other',
];

export function mealTypeIcon(meal: MealType): string {
  switch (meal) {
    case 'breakfast':
      return '🌅';
    case 'lunch':
      return '☀️';
    case 'dinner':
      return '🌙';
    case 'snack':
      return '🍿';
  }
}